import type { FC } from "react";
import {
  checkAlpharunOperatedIntegrationEnabled,
  useAlpharunOperatedIntegrationDetailOutletContext,
} from "./alpharunOperatedIntegrationDetailSection.js";
import { RecordingImportsTab } from "./recordingImportsTab.js";

/**
 * The **Failed imports** tab of an Alpharun-operated integration: the generic
 * recording-imports surface over the company's row.
 */
export const AlpharunOperatedIntegrationImportsTab: FC = () => {
  const { integration, config } =
    useAlpharunOperatedIntegrationDetailOutletContext();
  // While Alpharun has paused the import, the API refuses reprocess and skip
  // (400), so the tab hides the actions.
  return (
    <RecordingImportsTab
      integrationId={integration.id}
      provider={integration.provider}
      isPaused={!checkAlpharunOperatedIntegrationEnabled(integration)}
      description={`Call recordings from ${config.name} that couldn't be imported. Reprocess a recording to try importing it again, or skip it to dismiss it.`}
    />
  );
};
